import React from 'react'
import {Link} from 'react-router-dom'

const ServicesCard = () => {
    return (
        <div className="services-card">
            <div className="services-card-header">
                <img src="https://picsum.photos/200/300" />
            </div>
            <div className="services-card-content">
                <h1>Denetim Hizmetleri</h1>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                <Link to="services/servis-1" >
                    <button >Read more</button>
                </Link>
            </div>
        </div>
    )
}

export default ServicesCard
